export const animations = {
  splash: require('./splash_anim.json'),
  loading: require('./component_loading.json'),
  loading2: require('./component_loading2.json'),
  error: require('./error.json'),
  queue_animation: require('./queue_anim.json'),
  patient_waiting_animation: require('./patient_waiting_animation.json'),
  mic: require('./mic.json'),
  doctor_queue_notification_animation: require('./doctor_queue_notification_animation.json'),
  spinner_big: require('./spinner_big.json'),
  spinner: require('./spinner.json'),
};
